import { useState } from "react";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";

/** Represents the loading, data, and error state for the Review Pending Orders table. */
export interface ReviewPendingOrdersState {
  data?: PostgresResponseForMedicalPaOrders;
  loading?: boolean;
  error?: string;
  showinLineLoader?: boolean;
  totalCount?: number;
}

/**
 * Manages local state for the Review Pending Orders table: the raw Postgres response
 * (loading/data/error) and the derived table row data array.
 *
 * @returns State values and setters for reviewPendingOrdersState and tableData
 */
export const useReviewPendingOrdersTableData = () => {
  const [tableData, setTableData] = useState<MyMedicalPaOrdersTableData[]>([]);
  const [reviewPendingOrdersState, setReviewPendingOrdersState] =
    useState<ReviewPendingOrdersState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    reviewPendingOrdersState,
    setReviewPendingOrdersState,
    tableData,
    setTableData,
  };
};
